import { Skeleton } from 'antd';

export const PublicDecksSkeleton = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Header Skeleton */}
      <div className="mb-12">
        <div className="max-w-3xl">
          <Skeleton.Input active size="large" className="!w-[70%] !h-[40px] !mb-4" />
          <Skeleton active paragraph={{ rows: 2 }} />
        </div>

        {/* Statistics Skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          {[...Array(3)].map((_, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <div className="flex items-center gap-3">
                <Skeleton.Avatar active size="large" shape="square" />
                <div className="flex-1">
                  <Skeleton active paragraph={{ rows: 1 }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Guide Skeleton */}
      <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl p-6 mb-12">
        <Skeleton.Input active size="large" className="!w-[40%] !mb-4" />
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[...Array(4)].map((_, index) => (
            <div key={index}>
              <Skeleton active paragraph={{ rows: 2 }} />
            </div>
          ))}
        </div>
      </div>

      {/* Filters Skeleton */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
        <div>
          <Skeleton.Input active size="large" className="!w-[60%] !mb-2" />
          <Skeleton.Input active size="small" className="!w-[40%]" />
        </div>
        <div className="bg-white rounded-lg shadow-sm p-1">
          <Skeleton.Button active size="large" className="!w-[200px]" />
        </div>
      </div>

      {/* Decks List Skeleton */}
      <div className="w-full">
        <div className="flex justify-between items-center mb-3 sm:mb-5">
          <Skeleton.Input active size="large" className="!w-[120px]" />
          <div className="flex sm:hidden space-x-1">
            {[...Array(3)].map((_, index) => (
              <Skeleton.Button key={index} active size="small" className="!w-[60px]" />
            ))}
          </div>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-2 sm:gap-3 md:gap-4">
          {[...Array(12)].map((_, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100 h-[280px]">
              <div className="bg-gradient-to-r from-indigo-50 to-indigo-100 px-3 py-2 border-b border-indigo-100">
                <div className="flex items-center justify-between">
                  <Skeleton.Input active size="small" className="!w-[60%]" />
                  <Skeleton.Avatar active size="small" shape="circle" />
                </div>
              </div>
              <div className="p-3">
                <div className="flex items-center gap-1 mb-2">
                  <Skeleton.Input active size="small" className="!w-[40%]" />
                  <Skeleton.Input active size="small" className="!w-[30%]" />
                </div>
                <div className="bg-gray-50 p-2 rounded-lg mb-3">
                  <div className="flex flex-wrap justify-center gap-1">
                    {[...Array(6)].map((_, cardIndex) => (
                      <Skeleton.Image key={cardIndex} active className="!w-[40px] !h-[56px]" />
                    ))}
                  </div>
                </div>
                <Skeleton.Input active size="small" className="!w-full" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}; 